import AlertCookies from './cookies/script';
import VideoPopup from './video-popup/script';

export default {
	[AlertCookies.selector]: AlertCookies,
	[VideoPopup.selector]: VideoPopup
};
